<mh-alerts-wrapper>
    <!-- Sin cabecera: el contenido recibe los 26 px del estándar -->
    <mh-core-lib-content [shouldShowHeader]="false">
  
      <ng-container main-content>
        <router-outlet></router-outlet>
      </ng-container>
    </mh-core-lib-content>
  </mh-alerts-wrapper>
  